import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

function isMobile(){
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if(flag != null){
    return true
  } else {
    return false
  }
}

var router
if(isMobile()){
   router = new Router({
    mode: "history",
    routes: [
      {
        path: '/',
        name: 'index',
        component: resolve=>(require(["@/components/jc_h5/Index"],resolve))
      },
      {
        path: '/product',
        name: 'product',
        component: resolve=>(require(["@/components/jc_h5/Product"],resolve))
      },
      {
        path: '/purchase',
        name: 'purchase',
        component: resolve=>(require(["@/components/jc_h5/Purchase"],resolve))
      },
      {
        path: '/about',
        name: 'about',
        component: resolve=>(require(["@/components/jc_h5/About"],resolve))
      },
    ]
  })
} else {
  router = new Router({
    mode: "history",
    routes: [
      {
        path: '/',
        name: 'index',
        component: resolve=>(require(["@/components/jc_pages/Index"],resolve))
      },
      {
        path: '/product',
        name: 'product',
        component: resolve=>(require(["@/components/jc_pages/Product"],resolve))
      },
      {
        path: '/purchase',
        name: 'purchase',
        component: resolve=>(require(["@/components/jc_pages/Purchase"],resolve))
      },
      {
        path: '/about',
        name: 'about',
        component: resolve=>(require(["@/components/jc_pages/About"],resolve))
      },
    ]
  })
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js